// FEEL: add-to-cart for FEEL product cards (any form[data-feel-add]). Posts to the cart, then fires the
// theme's own CartAddEvent so the header bubble updates and the cart drawer opens, same as native buttons.
import { CartAddEvent } from '@theme/events';

if (!window.__feelCart) {
  window.__feelCart = true;
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest && e.target.closest('form[data-feel-add]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('button[type="submit"]');
    const label = form.querySelector('.feel-add__label');
    const original = label ? label.textContent : '';
    if (btn) btn.disabled = true;
    const fd = new FormData(form);
    const ids = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
    if (ids.length) fd.append('sections', ids.join(','));
    try {
      const res = await fetch((window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'text/html' },
        body: fd,
      });
      const json = await res.json();
      if (json.status) {
        if (label) label.textContent = json.description || json.message || 'Sold out';
        return;
      }
      form.dispatchEvent(new CartAddEvent({}, String(fd.get('id')), {
        source: 'product-form-component', itemCount: 1, productId: form.dataset.productId, sections: json.sections,
      }));
      form.classList.add('is-added');
      if (label) label.textContent = 'Added';
      setTimeout(() => { form.classList.remove('is-added'); if (label) label.textContent = original; }, 1600);
    } catch (err) {
      form.submit();
    } finally {
      if (btn) btn.disabled = false;
    }
  });
}
